import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Link, useNavigate } from "react-router-dom";

export default function Footer({ }) {
    const navigate = useNavigate();

    const {t} = useTranslation()



	return (
		<footer id="contact">
            <div className="footer_wrapper">
                <div className="created_by">
                    <img src="/assets/images/footer_logo.png" style={{ cursor: "pointer" }} onClick={() => window.scrollTo({top: 0, left: 0, behavior: 'smooth' })} alt="" />
                    <div className="sc_links show_sm">
                        <a href="https://www.facebook.com/profile.php?id=61559737107596" target="_blank">
                            <img src="/assets/images/Facebook.png" alt="" />
                        </a>
                        <a href="https://www.instagram.com/minicube.ge/" target="_blank">
                            <img src="/assets/images/Instagram.png" alt="" />
                        </a>
                        <a href="https://www.tiktok.com/@minicube.ge" target="_blank">
                            <img src="/assets/images/tiktok.png" alt="" />
                        </a>
                    </div>
                    <h5><a href="https://www.facebook.com/burtulacreative" target="_blank">Created by Burtula</a></h5>
                    <p>© 2024 Minicube.ge</p>
                    <p>ყველა უფლება დაცულია</p>
                </div>
                <div className="social_links">
                    <img src="/assets/images/Isolation_Mode.png" alt="" />
                    <div className="social_media">
                        <h2>{t("follow")}</h2>
                        <div className="sc_links">
                            <a href="https://www.facebook.com/profile.php?id=61559737107596" target="_blank">
                                <img src="/assets/images/Facebook.png" alt="" />
                            </a>
                            <a href="https://www.instagram.com/minicube.ge/" target="_blank">
                                <img src="/assets/images/Instagram.png" alt="" />
                            </a>
                            <a href="https://www.tiktok.com/@minicube.ge" target="_blank">
                                <img src="/assets/images/tiktok.png" alt="" />
                            </a>
                        </div>
                    </div>
                    <img src="/assets/images/love.png" alt="" />
                </div>
                <div className="footer_contact">
                    <h2>{t("contact")}</h2>
                    <div className="contact_links">
                        <a href="mailto:info@minicube.ge">
                            <img src="/assets/images/Email.png" alt="" />
                            info@minicube.ge
                        </a>
                        <a href="tel:+995551639639">
                            <img src="/assets/images/Phone.png" alt="" />
                            +995 551 639 639
                        </a>
                        <a href="">
                            <img src="/assets/images/Mark.png" alt="" />
                            {t("address")}
                        </a>
                    </div>
                </div>
            </div>

            <div className="all_rights">
                <p>© 2024 Minicube.ge {t("all_rights_reseved")}</p>
                <a href="https://www.facebook.com/burtulacreative" target="_blank"><img src="/assets/images/pencil.png" alt="" />{t("created_by")}</a>
            </div>
        </footer>
	);
}
